<template>
 <div>
   <section class="prizes top_block">
     <div class="top_block_content">
       <div class="top_block_content__center">
         <div class="top_block_header">
           <img class="avatar" src="static/images/prize_leaderboard.svg" alt=""></div>
           <div class="tab-header">
             <a @click.prevent="changeTypeValue('DAILY')" :class="[ (prizeInfo.type === 'DAILY') ? 'active' : '', (!missingTab())? 'small_font' : '', (getAvailablePrizeTypes.indexOf('DAILY') === -1)? 'tab_off' : '']"
                data-target="daily" style="cursor:pointer">{{ getTranslations.home_prizes_and_leaderboards_daily }}</a>
             <a @click.prevent="changeTypeValue('WEEKLY')" :class="[ (prizeInfo.type === 'WEEKLY') ? 'active' : '',(!missingTab())? 'small_font' : '', (getAvailablePrizeTypes.indexOf('WEEKLY') === -1)? 'tab_off' : '']"
                data-target="weekly" style="cursor:pointer">{{ getTranslations.home_prizes_and_leaderboards_weekly }}</a>
             <a @click.prevent="changeTypeValue('MONTHLY')" :class="[ (prizeInfo.type === 'MONTHLY') ? 'active' : '', (!missingTab())? 'small_font' : '', (getAvailablePrizeTypes.indexOf('MONTHLY') === -1)? 'tab_off' : '']"
                data-target="monthly" style="cursor:pointer">{{ getTranslations.home_prizes_and_leaderboards_monthly}}</a>
             <a @click.prevent="changeTypeValue('GRAND')" :class="[ (prizeInfo.type === 'GRAND') ? 'active' : '', (!missingTab())? 'small_font' : '', (getAvailablePrizeTypes.indexOf('GRAND') === -1)? 'tab_off' : '']"
                data-target="grand" style="cursor:pointer">{{ getTranslations.home_prizes_and_leaderboards_grand_prize }}</a>
           </div>
         </div>
     </div>
     <div class="prizes__content">
       <div class="tab-container">
         <div v-for="(type, key) in ['DAILY', 'WEEKLY', 'MONTHLY', 'GRAND']"
              v-if = "prizeInfo.type === type"
              :class="['tab-container__item', (prizeInfo.type === type) ? 'active' : '' ]"
              :key="key">
           <DateTab :type="prizeInfo.type"
                    :get-date-format="getDateFormat"
                    :prizes="infoByCategory[type].prizes"
                    :click-on-image="clickOnImage">
           </DateTab>
           <PrizeTab v-for ="(day,index) in [0, 1, 2]"
                     v-if="infoByCategory[type].winners &&
                           infoByCategory[type].rank &&
                           infoByCategory[type].tabActive === day"
                     :day = "infoByCategory[type].tabActive"
                     :type="prizeInfo.type"
                     :winners="infoByCategory[type].winners ? infoByCategory[type].winners[day] : []"
                     :get-rank="infoByCategory[type].rank ? infoByCategory[type].rank[day] : []"
                     :updatePoints="updatePoints"
                     :refreshedDate="infoByCategory[type].prizes[day] ? infoByCategory[type].prizes[day].lastRefreshed: ''"
                     :get-date-format="getDateFormat"
                     :key="index">
           </PrizeTab>
         </div>
       </div>
     </div>
   </section>
   <fade-transition>
     <details-leader v-if="showmodal" :get-modal-for-prize-leaderboard="modalPrize" @close="onModalClose()"/>
   </fade-transition>
 </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import bus from '@/common/eventBus';
import PrizeTab from './PrizeTab';
import DateTab from './DateTab';
import DetailsLeader from '../modals/prizes/PrizeDetailsForLeaderBoard';

export default {
  name: 'prizes-and-leaderboards',
  components: {
    DateTab,
    PrizeTab,
    DetailsLeader,
    FadeTransition,
  },
  data() {
    return {
      modalPrize: {},
      availableTypes: [],
      prizeInfo: {
        type: 'DAILY',
      },
      showmodal: false,
      infoByCategory: {
        DAILY: {
          winners: [[], [], []],
          prizes: [{}, {}, {}],
          tabActive: 2, // 2 for today, 1 for one day ago , 0 for two days ago
          rank: [{}, {}, {}],
        },
        WEEKLY: {
          winners: [[], [], []],
          prizes: [{}, {}, {}],
          tabActive: 2,
          rank: [{}, {}, {}],
        },
        MONTHLY: {
          winners: [[], [], []],
          prizes: [{}, {}, {}],
          tabActive: 2,
          rank: [{}, {}, {}],
        },
        GRAND: {
          winners: [[], [], []],
          prizes: [{}, {}, {}],
          tabActive: 2,
          rank: [{}, {}, {}],
        },
      },
    };
  },
  created() {
    bus.$on('favorite', (user) => {
      Object.keys(this.infoByCategory).forEach((key) => {
        this.infoByCategory[key].winners = this.infoByCategory[key].winners
          .map(winnerKey => winnerKey.map(winner => ((winner.username === user) ? { ...winner, favorite: !winner.favorite } : winner)));
      });
    });
    this.storeAvailablePrizeTypes(this.getLocale).then(() => {
      this.fetchData();
    });
  },
  beforeDestroy() {
    bus.$off();
  },
  methods: {
    ...mapActions('profile', [
      'storePrizesAndWinners',
      'storeAvailablePrizeTypes',
    ]),
    updatePoints() {
      this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
        this.fetchData();
      });
    },
    initCarousel() {
      const self = this;
      this.$nextTick(() => {
        /* eslint-disable */
        $('.owl-carousel').owlCarousel({
          loop: false,
          responsiveClass: true,
          dots: true,
          navContainer: '.carousel__nav',
          dotsContainer: '.prizes__carousel__dots',
          navText: ['<i class=\'icon-arrow-left\'></i>', '<i class=\'icon-arrow-right\'></i>'],
          responsive: {
            0: {
              items: 1,
              nav: true,
              onInitialized: function() {
                $(".icon-arrow-left").addClass("deactivated");
              },
              onTranslated: function(event){
                $('.icon-arrow-right').removeClass('deactivated');
                $('.icon-arrow-left').removeClass('deactivated');
                if (event.item.index === 0){
                  $(".icon-arrow-left").addClass("deactivated");
                } else {
                  $(".icon-arrow-left").show();
                }
                if (event.item.index === (event.item.count - 1)){
                  $(".icon-arrow-right").addClass("deactivated");
                }
                else {
                  $(".icon-arrow-right").show();
                }
              }
            },
          },
        }).on('changed.owl.carousel', function(event) {
          let currentTab = Math.abs(event.page.index - (event.relatedTarget._clones.length / 2));
          self.changeDay(currentTab);
        }).on('click', '.item', function () {
          self.clickOnImage(self.infoByCategory[self.prizeInfo.type].prizes[self.infoByCategory[self.prizeInfo.type].tabActive]);
        }).trigger('to.owl.carousel', self.infoByCategory[self.prizeInfo.type].tabActive - (3 - self.getNumOfPrizesPerType(self.prizeInfo.type)));
      });
      /* eslint-enable */
    },
    setCategoryInfo() {
      if (this.prizeInfo.type === 'DAILY') {
        this.infoByCategory[this.prizeInfo.type].winners = this.getDailyWinnersForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].prizes = this.getDailyPrizeForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].rank = this.getDailyRankForLeaderboard;
      } else if (this.prizeInfo.type === 'WEEKLY') {
        this.infoByCategory[this.prizeInfo.type].winners = this.getWeeklyWinnersForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].prizes = this.getWeeklyPrizeForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].rank = this.getWeeklyRankForLeaderboard;
      } else if (this.prizeInfo.type === 'MONTHLY') {
        this.infoByCategory[this.prizeInfo.type].winners = this.getMonthlyWinnersForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].prizes = this.getMonthlyPrizeForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].rank = this.getMonthlyRankForLeaderboard;
      } else if (this.prizeInfo.type === 'GRAND') {
        this.infoByCategory[this.prizeInfo.type].winners = this.getGrandWinnersForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].prizes = this.getGrandPrizeForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].rank = this.getGrandRankForLeaderboard;
      }
    },
    missingTab() {
      return (this.getAvailablePrizeTypes.length !== 4);
    },
    changeTypeValue(type) {
      this.prizeInfo.type = type;
      const userData = {
        language: this.getLocale,
        prizeType: this.prizeInfo.type,
      };
      this.storePrizesAndWinners(userData).then(() => {
        this.setCategoryInfo();
        this.initCarousel();
      });
    },
    initActiveTab() {
      if (this.getAvailablePrizeTypes.indexOf('DAILY') !== -1) {
        this.prizeInfo.type = 'DAILY';
      } else if (this.getAvailablePrizeTypes.indexOf('WEEKLY') !== -1) {
        this.prizeInfo.type = 'WEEKLY';
      } else if (this.getAvailablePrizeTypes.indexOf('MONTHLY') !== -1) {
        this.prizeInfo.type = 'MONTHLY';
      } else if (this.getAvailablePrizeTypes.indexOf('GRAND') !== -1) {
        this.prizeInfo.type = 'GRAND';
      }
    },
    getNumOfPrizesPerType(type) {
      return this.infoByCategory[type].prizes.filter(item => item.activeFrom).length;
    },
    changeDay(day) {
      const availablePrizesForType = this.getNumOfPrizesPerType(this.prizeInfo.type);
      this.infoByCategory[this.prizeInfo.type].tabActive = (3 - availablePrizesForType) + day;
    },
    fetchData() {
      this.initActiveTab();
      const userData = {
        language: this.getLocale,
        prizeType: this.prizeInfo.type,
      };
      this.storePrizesAndWinners(userData).then(() => {
        this.setCategoryInfo();
        this.initCarousel();
      });
    },
    getDateFormat(date, format) {
      this.$moment.locale(this.getLocale.toLowerCase());
      return this.$moment(date).format(format);
    },
    clickOnImage(prize) {
      this.modalPrize = prize;
      this.showmodal = true;
    },
    onModalClose() {
      this.showmodal = false;
      if (this.modalPrize && Object.keys(this.modalPrize).length) {
        this.modalPrize = {};
      }
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getDailyWinnersForLeaderboard',
      'getWeeklyWinnersForLeaderboard',
      'getMonthlyWinnersForLeaderboard',
      'getDailyPrizeForLeaderboard',
      'getWeeklyPrizeForLeaderboard',
      'getMonthlyPrizeForLeaderboard',
      'getGrandWinnersForLeaderboard',
      'getGrandRankForLeaderboard',
      'getDailyRankForLeaderboard',
      'getWeeklyRankForLeaderboard',
      'getMonthlyRankForLeaderboard',
      'getGrandPrizeForLeaderboard',
      'getAvailablePrizeTypes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/PrizesAndLeaderboards.vue